<template>
	<van-notify v-model:show="internalShow" :duration="duration" :class="notifyClass">
		<i v-if="type === 'success'" class="iconfont icon-danxuankuang-031" style="margin-right: 4px; font-size: 1.33rem"></i>
		<i v-else-if="type === 'warning'" class="iconfont icon-tanhao" style="margin-right: 4px; font-size: 1.33rem"></i>
		<i v-else-if="type === 'primary'" class="iconfont icon-gonggao" style="margin-right: 4px; font-size: 1.33rem"></i>
		<span>
			<slot>{{ message }}</slot>
		</span>
	</van-notify>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';

const props = defineProps({
	type: {
		type: String, // 'primary'|'success'|'warning'
		default: 'primary',
	},
	message: {
		type: String,
		default: '',
	},
	modelValue: {
		type: Boolean,
		default: false,
	},
	duration: {
		type: Number,
		default: 3000,
	},
});

const emit = defineEmits(['update:modelValue']);

// 初始为 false，避免 SSR hydration 问题
const internalShow = ref(false);

const notifyClass = computed(() => `dc-notify-${props.type}`);

// 组件挂载后再显示，避免 hydration 问题
onMounted(() => {
	if (props.modelValue) {
		// 使用 nextTick 确保样式已经应用
		internalShow.value = true;

		// 设置定时器自动关闭
		setTimeout(() => {
			internalShow.value = false;
		}, props.duration);
	}
});

// 监听 props.modelValue 变化
watch(
	() => props.modelValue,
	newVal => {
		internalShow.value = newVal;
		if (newVal) {
			setTimeout(() => {
				internalShow.value = false;
			}, props.duration);
		}
	}
);

// 监听 internalShow 变化，同步给父组件
watch(
	() => internalShow.value,
	newVal => {
		emit('update:modelValue', newVal);
	}
);
</script>

<style scoped lang="scss"></style>
